const prompts = [
  "How can technology be integrated into traditional farming methods to improve efficiency?",
  "What is organic farming? ",
  "What are some innovative ways farmers are conserving water resources in agriculture?",
  "In what ways can small-scale farmers benefit from leveraging data analytics and AI technology in their operations?",
];
export default prompts;
